module.exports = __webpack_public_path__ + "img/cw_yf_heSuanBaoBiao.0c798c47.svg";